import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appAlphanumericOnly]'
})
export class AlphanumericOnlyDirective {

  constructor() { }

  @HostListener('keypress', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const inputChar = event.key;
    const isAlphanumeric = /^[a-zA-Z0-9]*$/.test(inputChar);
    if (!isAlphanumeric) {
      event.preventDefault();
    }
  }
}